import { useQuery } from 'react-query';
import dynamicAPI from './dynamicAPI';

export default function useSpaceSuggestions({ spaceId, page = 1, limit = 50 }) {
    return useQuery(
        ['space-suggestions', spaceId, page, limit],
        async () => {
            const res = await dynamicAPI(
                'get',
                `/api/auth/space-suggestions/${spaceId}?page=${page}&limit=${limit}`
            );
            if (res?.error) throw new Error(res.error);
            return res; // { data, page, pages, total }
        },
        { enabled: !!spaceId, staleTime: 15_000, retry: 0 }
    );
}
